import { Link } from 'react-router-dom';
import { Button, Typography } from 'antd';
import './styles.css';

interface ErrorPageTemplateProps {
    errorImage: string;
    errorDescription: string;
    buttonText: string;
    buttonLink: string;
}

export default function ErrorPageTemplate({
    errorImage,
    errorDescription,
    buttonText,
    buttonLink
}: ErrorPageTemplateProps) {

    return (
        <div className="error-page-container">
            <img
                className="error-page-bg-img"
                src='img/common_background.jpg'
                alt='background escritorio'
            />
            <div className="error-page-content">
                <div className="error-page-card">
                    <div className="error-page-image-container">
                        <img
                            className="error-page-image"
                            src={errorImage}
                            alt='error illustration'
                        />
                    </div>
                    <div className="error-page-text-container">
                        <Typography.Text className="error-page-description">
                            {errorDescription}
                        </Typography.Text>
                        <Link to={buttonLink}>
                            <Button
                                type="primary"
                                className="error-page-button"
                            >
                                {buttonText}
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
